import { Switch } from '../../ui';
import { useFieldContext } from '../FieldContext';

export function BooleanInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  return (
    <Switch
      checked={value === true}
      onCheckedChange={onChange}
      disabled={readOnly}
      ariaLabel={field.label}
      label={value === true ? 'Yes' : 'No'}
    />
  );
}
